import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//constant
import { choicesCommentsLibraryShow } from 'constants';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input';

const FiltersTableCommentsLibrary = ({
  formFilter,
  setFormFilter,
  handleClear,
  t,
  page,
  setPage
}) => {
  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.user}
          label={t('commentLibrary.user')}
          placeholder={t('correoelectronico')}
          onChange={(e) => handleSearch(e, 'user')}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.library}
          label={t('commentLibrary.library')}
          placeholder={t('commentLibrary.fiscalName')}
          onChange={(e) => handleSearch(e, 'library')}
        />
        <SelectInputCustom
          label={t('commentLibrary.select')}
          choices={choicesCommentsLibraryShow(t)}
          onCheckedItem={(e) => handleSearch(e, 'show')}
          value={formFilter.show}
        />
      </Form>
    </SearchTable>
  );
};

FiltersTableCommentsLibrary.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableCommentsLibrary;
